module.exports = __webpack_public_path__ + "static/media/RPG_750.c701286e.png";